import logo from './logo.svg';
import './App.css';
import SaamiTradestarLogistics from './Components/SaamiTradestarLogistics';
import Login from './Components/Login';
// import { useState } from "react";
import { useEffect, useState } from "react";
import api from "./api";

function App() {
  // const [isLoggedIn, setIsLoggedIn] = useState(
  //   localStorage.getItem("isLoggedIn") === "true"
  // );

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  //lgoicfor after 30 mins user auto logout without refresh
  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = () => {
    const loginTime = localStorage.getItem("loginTime");
    const savedLogin = localStorage.getItem("isLoggedIn");

    if (savedLogin === "true" && loginTime) {
      const now = Date.now();
      const diff = now - Number(loginTime);

      const thirtyMinutes = 30 * 60 * 1000;

      if (diff < thirtyMinutes) {
        setIsLoggedIn(true);

        // remaining time
        const remainingTime = thirtyMinutes - diff;

        // Auto logout exactly when session expires
        setTimeout(() => {
          logoutUser();
          alert("Session expired. Please login again.");
        }, remainingTime);
      } else {
        logoutUser();
      }
    }
  };

  //ConCurrent Login
  useEffect(() => {
    if (isLoggedIn) {
      const interval = setInterval(async () => {
        try {
          const sessionToken = localStorage.getItem("sessionToken");
          if (!sessionToken) return;

          // Standardize the URL. If /login works, /check-session should likely be at the same level.
          await api.get("/check-session", {
            headers: {
              SessionToken: sessionToken
            }
          });
        } catch (error) {
          console.error("Session check failed:", error.response?.status, error.response?.data || error.message);
          
          // Only logout if it's a 401 Unauthorized (which means token mismatch)
          if (error.response?.status === 401) {
            logoutUser();
            alert("Logged in from another PC. You have been logged out.");
          } else {
            console.warn("Session check error (Non-401):", error.message);
          }
        }
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isLoggedIn]);

  const logoutUser = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("token");
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("username");
    localStorage.removeItem("loginTime");
    setIsLoggedIn(false);
  };


  return (
    <div className="App">

      {/* {isLoggedIn ? (
        <SaamiTradestarLogistics />
      ) : (
        <Login setIsLoggedIn={setIsLoggedIn} />
      )} */}

      {isLoggedIn ? (
        <SaamiTradestarLogistics logoutUser={logoutUser} />
      ) : (
        <Login setIsLoggedIn={setIsLoggedIn} />
      )}
    </div>
  );
}

export default App;
